import { render, staticRenderFns } from "./popoverTva.vue?vue&type=template&id=42eda394&"
import script from "./popoverTva.vue?vue&type=script&lang=js&"
export * from "./popoverTva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports